/* eslint-disable import/prefer-default-export */
import { IMPORTING } from 'pcb-parts/data/bomStatus';
import { selectDataToInitializeBom } from 'pcb-parts/slice/selectors';
import {
  changeBomFile,
  checkBomInitialValues,
  replaceBomWorkbook,
  replaceBomParameters,
  updateBomBoardQtys,
  updateBomStatus,
  updateDataForImport,
  updateBomSelected,
} from 'pcb-parts/slice/bomSlice';

export const initializeBom = (bom_header, workbook, file_name) => async (dispatch, getState) => {
  const { board_qtys } = selectDataToInitializeBom(getState());
  dispatch(checkBomInitialValues({ name: 'PCBAssemblyExpress-Quote-for-parts', revision: 'REV 1' }));
  dispatch(replaceBomParameters(bom_header));
  dispatch(replaceBomWorkbook(workbook));
  dispatch(changeBomFile(file_name));
  dispatch(updateBomBoardQtys(board_qtys));
  dispatch(updateDataForImport());
  dispatch(updateBomSelected(true));
  dispatch(updateBomStatus(IMPORTING));
};
